import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { umsUrl, customHeaders, thriweDiscoveryUrl, thriweMarketPlaceUaeUrl, thriweMarketPlaceUrl } from './../../../../Containers/Config';
import { Constant } from './../../../../Containers/Helpers/constant';
import apiCall from './../../apiCall';
import { CHANGE_ACTIVITY, CHANGE_ACTIVITY_ERROR, CHANGE_ACTIVITY_SUCCESS } from './../../actionType';

function* changeActivity({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${umsUrl}/admin/v2/change-activity-state`,
      method: 'PUT',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        // 'Project-Code': 'GLOBE_TOYOTA',
        ...customHeaders,
      },
      data: payload?.data,
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: CHANGE_ACTIVITY_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: CHANGE_ACTIVITY_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CHANGE_ACTIVITY_ERROR, payload: error });
  }
}

export function* watchChangeActivity() {
  yield takeEvery(CHANGE_ACTIVITY, changeActivity);
}

function* changeActivitySaga() {
  yield all([fork(watchChangeActivity)]);
}

export default changeActivitySaga;
